export default {
  path: '/maintenance',
  component: () => import('@views/Maintenance/Index'),
  children: [
    {
      path: 'repairreturn',
      name: 'repairreturn.index',
      component: () => import('@/components/Maintenance/RepairReturn')
    },
    {
      path: 'materialequipment/:id',
      name: 'materialequipment.index',
      component: () => import('@/components/Maintenance/MaterialEquipment')
    }
  ]
}
